import React from 'react'
import OnboardingSectionTitle from '../../../_global/OnboardingSectionTitle'
import EducationDegreeForm from './Form'
import { Grid } from '@material-ui/core'
import { useOnboarding } from '../../../contexts/OnboardingContext'
import { useQuery } from '@apollo/react-hooks'
import EDUCATION_QUERY from '../../../apolloClient/queries/getEducation'
import Error from '../../../_global/Error'
import Loader from '../../../_global/Loader'

export const initialEducationValues = {
  degree: '',
  endDate: '',
  major: '',
  schoolName: '',
  startDate: '',
}

const Education = () => {
  const { currentExpert, arrayIsValid } = useOnboarding()

  const { loading, error, data } = useQuery(EDUCATION_QUERY, {
    variables: { id: currentExpert.id },
    skip: !currentExpert.id,
  })

  if (loading) return <Loader />
  if (error) return <Error />

  const {
    getExpert: { education, certificates, languages },
  } = data

  const initialValues = {
    educations: arrayIsValid(education) ? education : [initialEducationValues],
    certificates: arrayIsValid(certificates) ? certificates : [],
    languages: arrayIsValid(languages) ? languages : [],
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <OnboardingSectionTitle
          title="Education"
          description="Relevant education helps us match you more effectively with potential clients."
        ></OnboardingSectionTitle>
      </Grid>
      <Grid item xs={12}>
        <EducationDegreeForm initialValues={initialValues} />
      </Grid>
    </Grid>
  )
}

export default Education
